import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';

@Injectable()
export class RecaptchaService {

  constructor(public http: Http,private mainService: MainService) { }

  verify(response:String){
    let request = {response:response};
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"recaptcha",request)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/recaptcha.service.ts